module.exports = __webpack_public_path__ + "static/img/christina_karina_famille_homoparentale_suede.bb736c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christina_karina_famille_homoparentale_suede.jpg
// module id = 30
// module chunks = 1